import ApiBase from './ApiBase';
import { FulfillmentIssue } from '../types/fulfillments';

export default class ClaimService extends ApiBase {
  async findClaimSession(orderId) {
    const { data } = await this.client.get(`sessions?orderId=${orderId}`);

    return data;
  }

  async updateClaimSession(body) {
    const { data } = await this.client.put(`sessions`, body);

    return data;
  }

  async deleteClaimSession(id) {
    return this.client.delete(`sessions/${id}`);
  }

  async findClaimById(id) {
    const { data } = await this.client.get(`claims/${id}`);

    return data;
  }

  async findReviews(id) {
    const { data } = await this.client.get(`claims/${id}/reviews`);

    return data;
  }

  async createReview(review, claimId) {
    const { data } = await this.client.post(`claims/${claimId}/reviews`, review);

    return data;
  }

  async createClaimMessage(data, storeId, sourceOrderId) {
    return this.client.post(`claims/${sourceOrderId}/messages?storeId=${storeId}`, data);
  }

  async loadClaimMessages(claimId, sourceOrderId) {
    const { data } = await this.client.get(`claims/${sourceOrderId}/messages?claimId=${claimId}`);

    return data;
  }

  transformStoreToClaim(email, claimInfo) {
    return {
      email,
      fulfillmentIssues: Object.entries(claimInfo.fulfillments).reduce(
        (acc: FulfillmentIssue[], [sourceFulfillmentId, fulfillment]: [string, any]) => {
          acc.push({
            issues: fulfillment.issues.map(({ item, ...issue }) => ({
              ...issue,
            })),
            sourceFulfillmentId,
          });

          return acc;
        },
        [],
      ),
      resolution: {
        customerSignature: claimInfo.signature,
        desiredMethod: claimInfo.resolution.desiredMethod,
        updatedShippingAddress: claimInfo.resolution.updatedShippingAddress,
      },
    };
  }

  async createClaim({ claim, sourceOrderId }) {
    return this.client.post(`claims/${sourceOrderId}`, claim);
  }

  async createClaimFromValet({ claim, sourceOrderId }, options = {}) {
    return this.client.post(`claims/${sourceOrderId}/valet`, { ...claim, options });
  }

  async notifyClaimCustomer(claimId: string) {
    return this.client.post(`claims/notify/${claimId}/email`);
  }

  async saveCustomerSignature(claimId: string, updateData: { imageUrl: string; address?: unknown }) {
    return this.client.put(`claims/signature/${claimId}`, updateData);
  }
}
